import { pWarn } from '_/helpers/logger';
import { eventBus } from '_/helpers/eventBus';
import { mapGetters } from 'vuex';

export default {
    name: 'FloatNumber',
    props: {
        defaultValue: {
            type: [Number, String]
        },
        disabled: {
            type: Boolean
        },
        id: {
            required: true,
            type: [Number, String]
        },
        name: {
            required: true,
            type: String
        },
        placeholder: {
            type: String,
            default: 'Enter a decimal number'
        },
        refreshFields: {
            type: Number
        },
        value: {
            default: null,
            type: [Number, String]
        },
        focus: {
            default: false,
            type: Boolean
        },
        error: {
            type: String,
            default: ''
        }
    },

    computed: mapGetters({
        ui: 'ui/ui'
    }),

    methods: {
        createEventPayload(event) {
            const value = event.target.value === '' ? null : parseFloat(event.target.value);
            return {
                event,
                id: event.target.id,
                name: event.target.name,
                value
            };
        },

        onChange(event) {
            const payload = this.createEventPayload(event);
            this.$emit('change', payload);
            eventBus.$emit('fieldTypeChange', payload);
        },

        onBlur(event) {
            eventBus.$emit('fieldTypeBlur', this.createEventPayload(event));
        },

        setDefaultValueIfRequired() {
            if (this.value === null && this.defaultValue !== undefined) {
                this.$emit('change', {
                    id: this.id,
                    name: this.name,
                    value: parseFloat(this.defaultValue)
                });
            }
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.setDefaultValueIfRequired();

            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `FloatNumber.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.setDefaultValueIfRequired();
                this.$forceUpdate();
                $(this.$el).val(this.value);

                if (this.focus) {
                    $(this.$el).find(`#${this.id}`).focus();
                }
            }
        }
    }
};
